import { useRef } from 'react';
import yandexKitOrangeIcon from '../../assets/images/logos/yandex-kit-orange.webp';
import TextArea from './components/TextArea';
import { useUIText, useAppConstants } from '../../hooks/useConfig';
import './LetterWritingBlock.scss';

function LetterWritingBlock({
    field1 = '',
    field2 = '',
    field3 = '',
    onField1Change,
    onField2Change,
    onField3Change,
    onInputFocus,
    onInputBlur
}) {
    const UI_TEXT = useUIText();
    const APP_CONFIG = useAppConstants();

    // Создаем рефы для каждого поля
    const field1Ref = useRef(null);
    const field2Ref = useRef(null);
    const field3Ref = useRef(null);

    // Проверка платформы через Telegram данные
    const getPlatform = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const platformFromUrl = urlParams.get('test_platform');
        return platformFromUrl || window.Telegram?.WebApp?.platform;
    };

    const isMobile = () => {
        const platform = getPlatform();
        return platform === 'android' || platform === 'ios';
    };

    // Обработчик Enter для первого поля - переход ко второму
    const handleField1KeyDown = (e) => {
        if (e.key === 'Enter' && isMobile()) {
            e.preventDefault();
            setTimeout(() => {
                field2Ref.current?.focus();
            }, 0);
        }
    };

    // Обработчик Enter для второго поля - переход к третьему
    const handleField2KeyDown = (e) => {
        if (e.key === 'Enter' && isMobile()) {
            e.preventDefault();
            setTimeout(() => {
                field3Ref.current?.focus();
            }, 0);
        }
    };

    // Обработчик Enter для третьего поля - закрытие клавиатуры
    const handleField3KeyDown = (e) => {
        if (e.key === 'Enter' && isMobile()) {
            e.preventDefault();
            field3Ref.current?.blur();
        }
    };

    return (
        <div className="letter-writing-block">
            <img src={yandexKitOrangeIcon} alt="Yandex Kit" className="yandex-kit-logo" />
            <TextArea
                ref={field1Ref}
                maxLength={APP_CONFIG.LETTER?.MAX_LENGTHS?.FIELD_1}
                minLength={APP_CONFIG.LETTER?.MIN_LENGTHS?.FIELD_1}
                headerText={UI_TEXT.LETTER?.FIELDS?.FIELD_1?.HEADER}
                placeholderText={UI_TEXT.LETTER?.FIELDS?.FIELD_1?.PLACEHOLDER}
                value={field1}
                onChange={onField1Change}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                onKeyDown={handleField1KeyDown}
                enterKeyHint="next"
            />
            <TextArea
                ref={field2Ref}
                maxLength={APP_CONFIG.LETTER?.MAX_LENGTHS?.FIELD_2}
                minLength={APP_CONFIG.LETTER?.MIN_LENGTHS?.FIELD_2}
                headerText={UI_TEXT.LETTER?.FIELDS?.FIELD_2?.HEADER}
                placeholderText={UI_TEXT.LETTER?.FIELDS?.FIELD_2?.PLACEHOLDER}
                value={field2}
                onChange={onField2Change}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                onKeyDown={handleField2KeyDown}
                enterKeyHint="next"
            />
            <TextArea
                ref={field3Ref}
                maxLength={APP_CONFIG.LETTER?.MAX_LENGTHS?.FIELD_3}
                minLength={APP_CONFIG.LETTER?.MIN_LENGTHS?.FIELD_3}
                headerText={UI_TEXT.LETTER?.FIELDS?.FIELD_3?.HEADER}
                placeholderText={UI_TEXT.LETTER?.FIELDS?.FIELD_3?.PLACEHOLDER}
                value={field3}
                onChange={onField3Change}
                isSmallHeight={true}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                onKeyDown={handleField3KeyDown}
                enterKeyHint="done"
            />
        </div>
    );
}

export default LetterWritingBlock;

